




































































































































import store from '../store';
import { ProfileState, User, OrgData, ProfileData } from '@/store/profile/types';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { State, Action, Getter } from 'vuex-class';

const namespace: string = 'profile';

@Component
export default class Profile extends Vue {
    @Action('updateOrgInfo', { namespace }) private updateOrgInfo: any;
    @Action('refreshUser', { namespace }) private refreshUser: any;
    @Action('updateProfileInfo', { namespace }) private updateProfileInfo: any;
    @Getter('orgGetter', { namespace }) private orgGetter: OrgData | undefined;
    @Getter('profileGetter', { namespace }) private profileGetter: ProfileData | undefined;
    private formValid: boolean = true;
    private form2Valid: boolean = true;

    private originalAccForm: {
        [key: string]: string | string[],
    } = {
        name: '',
        email: '',
        region: '',
        country: '',
        birth: '',
        gender: '',
    };

    private accForm: {
        [key: string]: string | string[],
    } = {
        name: '',
        email: '',
        region: '',
        country: '',
        birth: '',
        gender: '',
    };

    private originalOrgForm: {
        [key: string]: string | string[],
    } = {
        firmName: '',
        orgNr: '',
        sector: '',
        target: '',
        employees: '',
        selectedPositions: [''],
        selectedTurnover: '',
    };

    private orgForm: {
        [key: string]: string | string[],
    } = {
        firmName: '',
        orgNr: '',
        sector: '',
        target: '',
        employees: '',
        selectedPositions: [''],
        selectedTurnover: '',
    };

    private orgs: string[] = ['testorg1', 'testorg2'];

    private yearRange: number[] = Array.from(new Array(120), (_, i) => i + (new Date().getFullYear() - 119)).reverse();

    private genders: string[] = [
        'Man',
        'Woman',
        'Other',
    ];

    private sectors: string[] = [
        'Agriculture, forestry & fishing',
        'Automotive',
        'Bank & finance',
        'Construction',
        'Consultancy services',
        'Energy',
        'Facility management',
        'Food',
        'Healthcare',
        'Hotel & restaurant',
        'Insurance',
        'Information & communication',
        'IT',
        'Law',
        'Manufacturing',
        'Mining',
        'Pharma',
        'Public sector',
        'Retail',
        'Services',
        'Startup',
        'Travelling',
        'University/academia',
        'Water supply',
    ];

    private targets: string[] = [
        'Consumers',
        'Companies',
    ];

    private employeeRanges: string[] = [
        '1-10',
        '11-50',
        '51-250',
        '250+',
    ];

    private turnoverRanges: string[] = [
        '0-1 million Euro',
        '1-4 million Euro',
        '5-10 million Euro',
        '11-25 million Euro',
        '26-50 million Euro',
        '51-100 million Euro',
        '101-250 million Euro',
        '251-500 million Euro',
        'more than 500 million Euro',
    ];

    private positions: string[] = [
        'CEO',
        'Part of the management team',
        'Marketing department',
        'HR department',
        'IT department',
        'Procurement department',
    ];

    private updatePage(newPage: string) {
        this.$emit('updatePage', newPage);
    }

    private logout() {
        this.$store.state.signedIn = false;
        this.$emit('signOut');
    }

    private async saveOrgChanges() {
        await this.updateOrgInfo({
            companyName: this.orgForm.firmName,
            orgNr: this.orgForm.orgNr,
            industry: this.orgForm.sector,
            targetGroup: this.orgForm.target,
            nrOfEmployees: this.orgForm.employees,
            turnover: this.orgForm.selectedTurnover,
            positions: this.orgForm.selectedPositions,
        });
        await this.refreshUser();
        this.setOrgInfo();
    }

    private setOrgInfo() {
        const newOrgInfo = this.orgGetter;
        if (newOrgInfo !== undefined) {
            this.originalOrgForm.firmName = newOrgInfo.name ?? '';
            this.originalOrgForm.orgNr = newOrgInfo.orgNr ?? '';
            this.originalOrgForm.sector = newOrgInfo.industry ?? '';
            this.originalOrgForm.employees = newOrgInfo.numberOfEmployees ?? '';
            this.originalOrgForm.target = newOrgInfo.targetGroup ?? '';
            this.originalOrgForm.selectedTurnover = newOrgInfo.turnover ?? '';
            this.originalOrgForm.selectedPositions = [newOrgInfo.members[0].positions] ?? [''];
        }
        this.orgForm = JSON.parse(JSON.stringify(this.originalOrgForm));
    }

    private async saveProfileChanges() {
        await this.updateProfileInfo({
            name: this.accForm.name,
            yearOfBirth: this.accForm.birth,
            region: this.accForm.region,
            country: this.accForm.country,
            gender: this.accForm.gender,
        });
        await this.refreshUser();
        this.setProfileInfo();
    }

    private setProfileInfo() {
        const newProfileInfo = this.profileGetter;
        if (newProfileInfo !== undefined) {
            this.originalAccForm.name = newProfileInfo.name ?? '';
            this.originalAccForm.email = newProfileInfo.email ?? '';
            this.originalAccForm.region = newProfileInfo.region ?? '';
            this.originalAccForm.country = newProfileInfo.country ?? '';
            this.originalAccForm.birth = newProfileInfo.birth ?? '';
            this.originalAccForm.gender = newProfileInfo.gender ?? '';
        }
        this.accForm = JSON.parse(JSON.stringify(this.originalAccForm));
    }
}

